import { useQuery } from "@tanstack/react-query";
import { getLandingContent, type LandingContentData } from "../api/landingContent";

export function useLandingContent() {
  return useQuery<LandingContentData>({
    queryKey: ["landing-content"],
    queryFn: getLandingContent,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
